// Top-up pack data model for the SaaS billing prototype.
// See plans/saas-billing/01-stripe-billing-foundation.md for canonical types.
//
// TopUpPrice is slimmer than PricePoint since top-ups are one-time charges,
// not recurring. No billingPeriod, no per-seat AI credit allocation.

import { CountryCode, CurrencyCode } from './subscription.model';

export interface TopUpPrice {
  currency: CurrencyCode;
  countryCode: CountryCode;
  amountMinor: number;
  stripePriceId: string | null;        // Populated post-backend-impl (one-time Price)
}

export interface TopUpPack {
  id: string;
  displayName: string;                 // "10,000 credits"
  credits: number;
  pricing: TopUpPrice[];               // Per currency, one-time pricing
}
